import { z } from "zod";
export type CampaignImageProvider = "fal" | "kie";
export interface CampaignFalRequest {
  endpoint: string;
  model: string;
  customerPricingModel: string;
  tier: string;
  payload: Record<string, unknown>;
}
export interface CampaignImageAttempt {
  provider: CampaignImageProvider;
  phase: "admitted" | "submitted" | "failed" | "complete" | "create_rejected";
  createRejection?: { httpStatus: number; providerCode?: number };
  taskId?: string;
  endpoint: string;
  imageUrl?: string;
}
export interface CampaignImageJournal {
  version: 1;
  fal: CampaignFalRequest;
  ratio: string;
  attempts: CampaignImageAttempt[];
  fallbackAuthorized: boolean;
  initialProvider?: CampaignImageProvider;
  supplierUnitCostUsd?: number;
  kieTier?: "1K" | "2K" | "4K";
}
export const campaignImageJournalSchema: z.ZodType<CampaignImageJournal, z.ZodTypeDef, unknown> = z.object({
  version: z.literal(1),
  fal: z.object({ endpoint: z.string().min(1), model: z.string().min(1),
    customerPricingModel: z.string().min(1), tier: z.string().min(1), payload: z.record(z.unknown()) }),
  ratio: z.string().min(1),
  fallbackAuthorized: z.boolean(),
  initialProvider: z.enum(["fal", "kie"]).optional(),
  kieTier: z.enum(["1K", "2K", "4K"]).optional(),
  // Old malformed pricing evidence is unknown, not an invalid paid identity.
  supplierUnitCostUsd: z.preprocess(value =>
    typeof value === "number" && Number.isFinite(value) && value >= 0 ? value : undefined,
    z.number().nonnegative().finite().optional()),
  attempts: z.array(z.object({
    provider: z.enum(["fal", "kie"]), phase: z.enum(["admitted", "submitted", "failed", "complete", "create_rejected"]),
    createRejection: z.object({ httpStatus: z.number().int(), providerCode: z.number().int().optional() }).optional(),
    taskId: z.string().min(1).optional(), endpoint: z.string().min(1), imageUrl: z.string().min(1).optional(),
  })).max(2),
});
